
import { toast } from '@/hooks/use-toast';
import { formatTitle } from './render-utils';
import { renderJpegTemplate } from './jpeg-template-renderer';

// Process JPEG export with high-resolution content-aware extraction
export const processJpegExport = async (
  drawingId: string,
  title: string,
  previewImage: string,
  analysisText?: string | null
): Promise<string> => {
  try {
    console.log('Starting high-resolution JPEG export process');
    
    // Use the improved template renderer to create a high-quality image
    // that focuses on the actual drawing content with enhanced analysis display
    return await renderJpegTemplate({
      title,
      drawingImage: previewImage,
      analysisText: analysisText || null,
      watermarkText: "Created with Surgical Drawing Studio",
      date: new Date(),
      // Enhanced styling parameters with visual improvements
      bgColor: "#ffffff",
      textColor: "#1A1F2C",
      accentColor: "#8B5CF6" // Purple accent color
    });
  } catch (error) {
    console.error('JPEG export process error:', error);
    throw error;
  }
};

export const downloadJpegFile = (dataUrl: string, drawingId: string, title: string): void => {
  const downloadLink = document.createElement('a');
  downloadLink.href = dataUrl;
  
  // Clean up the filename - replace underscores with spaces and then sanitize
  const formattedTitle = formatTitle(title);
  const sanitizedTitle = formattedTitle.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  downloadLink.download = `${sanitizedTitle}_${drawingId}.jpg`;
  
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  
  toast({
    title: "Export successful",
    description: "Your drawing has been exported as a high-resolution JPEG",
  });
};
